export class CanceledByUserException extends Error {
  constructor(message = 'Canceled by user') {
    super(message);
  }
}
